// extracted by mini-css-extract-plugin
export default {"nav_bar_sec":"HeaderFooter_nav_bar_sec__IdY6F","footer_main":"HeaderFooter_footer_main__w6Tpj","hsec4btn":"HeaderFooter_hsec4btn__CKSyQ"};